import { render, staticRenderFns } from "./SelectThird.vue?vue&type=template&id=dd7ad172"
import script from "./SelectThird.vue?vue&type=script&lang=js"
export * from "./SelectThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports